<template>
    <small class="is-block mb-4">
        <a href="javascript:;" @click="changeSorting('score-desc')" :class="{'orange-link': sort === 'score-desc'}" class="green-link" >{{ i18n.najoblubenejsie }}</a> &bull;
        <a href="javascript:;" @click="changeSorting('price-asc')" :class="{'orange-link': sort === 'price-asc'}" class="green-link" >{{ i18n.najlacnejsie }}</a>  &bull;
        <a href="javascript:;" @click="changeSorting('price-desc')" :class="{'orange-link': sort === 'price-desc'}" class="green-link" >{{ i18n.najdrahsie }}</a>
    </small>
<!--    <select v-model="sort">-->
<!--        <option value="score-desc">Najobľúbenejšie</option>-->
<!--        <option value="price-asc">Najlacnejšie</option>-->
<!--        <option value="price-desc">Najdrahšie</option>-->
<!--    </select>-->
</template>

<script>
    export default {
        props: {
            init_sort: String
        },
        name: "ProductsSortComponent",
        data: function() {
            return {
                sort: this.init_sort,
                i18n: i18n
            }
        },
        methods: {
            changeSorting(val) {
                let url = new URL(document.URL);
                url.searchParams.set('sort', val);
                url.searchParams.set('page', 1);

                window.location.href = url.href;
            }
        }
    }
</script>

<style scoped>

</style>
